import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore'
import { db } from '@/services/firebase/config'
import { DEFAULT_FINANCE_SETTINGS, type FinanceCalculatorSettings } from '@/types/financeSettings'

const SETTINGS_DOC_PATH = ['settings', 'financeCalculator'] as const

/**
 * Fetch the admin-managed Good Lending finance calculator settings.
 * Returns DEFAULT_FINANCE_SETTINGS (with enabled=false) when the doc doesn't
 * exist yet, so callers never have to null-check.
 */
export async function getFinanceCalculatorSettings(): Promise<FinanceCalculatorSettings> {
  const snapshot = await getDoc(doc(db, ...SETTINGS_DOC_PATH))
  if (!snapshot.exists()) return DEFAULT_FINANCE_SETTINGS
  const data = snapshot.data() as Partial<FinanceCalculatorSettings>
  return { ...DEFAULT_FINANCE_SETTINGS, ...data }
}

/**
 * Save the admin-managed Good Lending finance calculator settings.
 * Admin-only — enforced by Firestore rules on the `settings/` collection.
 */
export async function saveFinanceCalculatorSettings(
  settings: FinanceCalculatorSettings
): Promise<void> {
  await setDoc(
    doc(db, ...SETTINGS_DOC_PATH),
    { ...settings, updatedAt: serverTimestamp() },
    { merge: true },
  )
}
